import commonConfig from './common.config'
import localConfig from './local.config'
import developmentConfig from './development.config'
import productionConfig from './production.config'
import fictitiousConfig from './fictitious.config'

function buildConfig () {
  let envConfig = localConfig//默认本地环境
  switch (process.env.NODE_ENV) {
    //开发环境
    case 'development':
      envConfig = developmentConfig
      break
    //生产环境
    case 'production':
      envConfig = productionConfig
      break
    //虚拟机环境
    case 'fictitious':
      envConfig = fictitiousConfig
      break
  }
  return Object.assign(commonConfig, envConfig)
}

export default buildConfig()



// WEBPACK FOOTER //
// ./src/config/index.js